/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";

function NotAuthorized() {
    return (
        <div style={{display: "flex", justifyContent: "center", verticalAlign: "center", alignItems: "center", height: "20vh"}}>
            <h1>
                NOT AUTHORIZED
            </h1>
        </div>
    );
}

export default NotAuthorized;